const e = {
  name: "Coffee2",
  dimensions: { width: 30, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 30 40" style="enable-background:new 0 0 30 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M2,0h26v4h2v8h-2.1l-3,28H5.1l-3-28H0V4h2V0z M4,4h8.9l0.2,0.7C13.4,5.4,14.1,6,15,6c0.9,0,1.6-0.6,1.9-1.3
			L17.1,4H26V2H4V4z M28,6h-9.5c-0.7,1.2-2,2-3.5,2c-1.5,0-2.8-0.8-3.5-2H2v4h26V6z M4.8,18l1.5,14h17.5l1.5-14H4.8z M4.5,16h20.9
			l0.4-4H4.1L4.5,16z M6.9,38h16.2l0.4-4H6.5L6.9,38z"/>
	</g>
</g>
</svg>
  `
};
export {
  e as Coffee2
};
